// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1aZN4","title":"Images90_title__1hUC1","images":"Images90_images__1vBBC"};